import React, { PropsWithChildren } from "react";
import { useLocation } from "@gatsbyjs/reach-router";

export type AlgoliaTrackingParams = {
  objectID: string | null | undefined;
  queryID: string | null | undefined;
};

const AlgoliaAnalyticsParamsContext =
  React.createContext<AlgoliaTrackingParams>({
    queryID: null,
    objectID: null
  });

export const AlgoliaAnalyticsParamsProvider: React.FC<
  PropsWithChildren<{
    value: AlgoliaTrackingParams;
  }>
> = ({ value, children }) => {
  return (
    <AlgoliaAnalyticsParamsContext.Provider value={value}>
      {children}
    </AlgoliaAnalyticsParamsContext.Provider>
  );
};

export const AlgoliaAnalyticsParamsProviderFromURL: React.FC<
  PropsWithChildren<{
    objectID: string | null | undefined;
  }>
> = ({ children, objectID }) => {
  const { search } = useLocation();
  const { queryID } = getAlgoliaTrackingIDsFromURL(search);

  return (
    <AlgoliaAnalyticsParamsProvider value={{ objectID, queryID }}>
      {children}
    </AlgoliaAnalyticsParamsProvider>
  );
};

export const useAlgoliaAnalyticsParams = () => {
  const context = React.useContext(AlgoliaAnalyticsParamsContext);
  if (context === undefined) {
    throw new Error(
      "useAlgoliaAnalytics must be used within a AlgoliaAnalyticsProvider"
    );
  }
  return context;
};

const getAlgoliaTrackingIDsFromURL = (searchQuery: string) => {
  const searchParams = new URLSearchParams(searchQuery);
  return {
    queryID: searchParams.get("queryID")
  };
};
